import React from "react";
import {Container, Header, Icon} from "semantic-ui-react";
import {SurveyFormModel} from "../model/SurveyFormModel";
import AppListPage from "../../common/AppListPage";
import {SurveyFormDataProvider} from "../service/SurveyFormDataProvider";
import {SurveyFormListOptions} from "../model/SurveyFormListOptions";
import SurveyFormDetails from "./SurveyFormDetails";
import {ColumnFormat} from "../../common/AppListDataGrid";
import styles from "../selection/index.module.css";
import {AppListMenuButton, defaultButtons} from "../../common/AppListMenu";
import {hasRole, UserRole} from "../../../helpers/UserRole";

interface Props {
}

const SurveyFormList = (props: Props) => {

    async function onButtonClick(button: string, focusedItem: SurveyFormModel | undefined, reloadCallback?: () => void) {
        if (button == "save" && focusedItem) {
            const element = document.createElement('a');
            const model = await (new SurveyFormDataProvider()).getByID(focusedItem.id);

            element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(model)));
            element.setAttribute('download', focusedItem.name + ".json");

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element)
        }
        if (button === "load") {
            var input = document.createElement('input');
            input.type = 'file';
            input.accept = 'application/json';

            input.onchange = (e) => {
                var file = (e.target as any).files[0];
                let reader = new FileReader();
                reader.onload = async () => {
                    // this 'text' is the content of the file
                    const text = reader.result;
                    if (text) {
                        const form = JSON.parse(text.toString()) as SurveyFormModel;
                        await (new SurveyFormDataProvider()).insert(form);
                        reloadCallback!();
                    }
                }
                reader.readAsText(file);

            }

            input.click();
        }
    }

    return <Container fluid>
        <Header attached> <Icon name="edit outline"/>Анкеты</Header>
        <Container fluid>
            <AppListPage<SurveyFormModel, SurveyFormListOptions>
                provider={new SurveyFormDataProvider()}
                getDetailsComponent={(context) => <SurveyFormDetails context={context}/>}
                columns={[
                    {
                        key: "name", name: "Наименование",
                        cellClass: () => styles.cell_bolder,
                    },
                    {
                        key: "created", name: "Дата создания", format: ColumnFormat.datetime,
                        cellClass: () => styles.cell_text_align_center,
                        width: 180,
                        sortDirection: "DESC",
                    }
                ]}
                newItemCreator={() => {
                    return {id: "", name: "", created: new Date(), questions: []}
                }}
                onButtonClick={onButtonClick}
                getDisabledButtons={(focusedItem?: SurveyFormModel) => {
                    let result: string[] = [];
                    if (!focusedItem) result.push('view', 'edit', 'delete', 'save');
                    if (hasRole(UserRole.OBSERVER)) result.push('edit', 'delete', 'add', 'load', 'save');
                    return result;
                }
                }
                menuButtons={defaultButtons.concat([{
                    key: "save",
                    name: "Выгрузить в файл",
                    icon: "download",
                    iconColor: "blue"
                } as AppListMenuButton,
                    {
                        key: "load",
                        name: "Загрузить из файла",
                        icon: "upload",
                        iconColor: "blue"
                    } as AppListMenuButton])}
            >
            </AppListPage>
        </Container>
    </Container>;
}

export default SurveyFormList;